import { render } from "./userbar.vue?vue&type=template&id=f88afc8a&scoped=true"
import script from "./userbar.vue?vue&type=script&lang=js"
export * from "./userbar.vue?vue&type=script&lang=js"

import "./userbar.vue?vue&type=style&index=0&id=f88afc8a&scoped=true&lang=css"

import exportComponent from "E:\\newwww\\weimj\\agency\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f88afc8a"]])

export default __exports__